import Chip, { chipClasses } from "@mui/material/Chip";
import { useTranslation } from "react-i18next";

const StoichiometryTableRoleChip = ({ role }: { role: string }) => {
  const { t } = useTranslation("common");

  const getRoleColor = (role: string) => {
    switch (role.toLowerCase()) {
      case "reactant":
        return { color: "#1566b7", backgroundColor: "#f5fbfe" }; // Blue
      case "product":
        return { color: "#2e7d32", backgroundColor: "#e8f5e9" }; // Green
      case "catalyst":
        return { color: "#7b1fa2", backgroundColor: "#f3e5f5" }; // Purple
      case "agent":
        return { color: "#b04500", backgroundColor: "#fff3e0" }; // Orange
      default:
        return { color: "#616161", backgroundColor: "#f5f5f5" }; // Grey
    }
  };

  const { color, backgroundColor } = getRoleColor(role);

  const getRoleLabel = (role: string) => {
    switch (role.toLowerCase()) {
      case "reactant":
        return t("stoichiometry.table.roles.reactant");
      case "product":
        return t("stoichiometry.table.roles.product");
      case "agent":
        return t("stoichiometry.table.roles.reagent");
      default:
        return role.toLowerCase();
    }
  };

  return (
    <Chip
      label={getRoleLabel(role)}
      size="small"
      sx={{
        color: `${color} !important`,
        backgroundColor: `${backgroundColor} !important`,
        border: `1px solid ${color}`,
        fontWeight: 500,
        textTransform: "lowercase",
        [`&.${chipClasses.filled}`]: {
          backgroundColor: `${backgroundColor} !important`,
          border: `1px solid ${color}`,
        },
      }}
    />
  );
};

export default StoichiometryTableRoleChip;
